import api from '../api';
import { tokenService } from '../auth/tokenService';

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${tokenService.getAccessToken()}` },
});

export const notificationsService = {
  // GET
  getByUser: async ({ userId, page = 1, items_per_page = 10 }) => {
    try {
      const res = await api.get(`notifications/user/${userId}`, {
        params: { page, items_per_page },
        ...authHeaders(),
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  // POST
  create: async (payload) => {
    try {
      const res = await api.post('notifications/', payload, authHeaders());
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  // PUT
  markAsRead: async (notificationId) => {
    try {
      const res = await api.put(`notifications/${notificationId}/read`, null, authHeaders());
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  // DELETE
  deleteById: async (notificationId) => {
    try {
      const res = await api.delete(`notifications/${notificationId}`, authHeaders());
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  // DELETE
  deleteMultiple: async (userId, notification_ids) => {
    try {
      const res = await api.delete(`notifications/user/${userId}/delete-multiple`, {
        ...authHeaders(),
        data: { notification_ids },
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  },
};
